import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';
import { fontSize, fontWeight } from 'src/assets/fonts-config';
import { FormComponent } from 'src/domains/layouts/shared/cms/form/Form.style';
import { ButtonsWrapper } from 'src/domains/layouts/shared/buttons/Button.style';
import { Input } from 'src/domains/layouts/shared/formComponents/input/Input';

export const FormWrapper = styled('div', { label: 'FormWrapper' })`
    max-width: 750px;
    padding: 16px;
`;

export const FormComponentWrapper = styled(FormComponent, { label: 'FormComponentWrapper' })``;

export const Header = styled('div', { label: 'Header' })`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0;
`;

export const Title = styled('h3', { label: 'Title' })`
    font-size: ${fontSize.xMedium};
    font-weight: ${fontWeight.bold};
    margin: 0 0 10px 0;
`;

export const FooterPreview = styled('div', { label: 'FooterPreview' })`
    font-family: Montserrat, Arial, Helvetica, sans-serif;
    font-size: ${fontSize.xRegular};
    background-color: ${mainColors.grays.gray300};
    border-radius: 8px;
    border: 1px solid ${mainColors.main.primary};
    color: ${mainColors.grays.gray500};
    margin-bottom: 16px;
    max-width: 750px;
    padding: 16px;
`;

export const FooterLink = styled('a', { label: 'FooterLink' })`
    text-decoration: none;
    color: ${mainColors.grays.gray400};
`;

export const FooterNoLink = styled('span', { label: 'FooterNoLink' })`
    color: ${mainColors.grays.gray400};
`;

export const InputsWrapper = styled('div', { label: 'InputsWrapper' })`
    display: flex;
    align-items: flex-start;
    flex-flow: row nowrap;
    > div:first-of-type {
        margin-right: 16px;
    }
`;

export const LicenceNumberInputWrapper = styled(Input, { label: 'LicenceNumberInputWrapper' })`
    width: 130px;
`;

export const LicenceNumberLinkInputWrapper = styled(Input, { label: 'LicenceNumberLinkInputWrapper' })`
    width: 310px;
`;

export const ButtonsInputsWrapper = styled(ButtonsWrapper, { label: 'ButtonsInputsWrapper' })`
    margin-left: 16px;
    margin-top: 24px;

    > button:not(:first-of-type) {
        margin-top: 0;
    }
`;
